/* Remove .no-js from html if JavaScript is enabled */
document.getElementsByTagName('html')[0].className = document.getElementsByTagName('html')[0].className.replace('no-js', "") + " js";

jQuery(document).ready(function ($) {

    /* Validation
    ---------------------------------------- */
    $('#form-contact').validate();

    /* Placeholder fix
    ---------------------------------------- */
    $('input, textarea').placeholder();

    /* Cookie Info
    ---------------------------------------- */
    if (Cookies.get('cookiesAcknowledged') != 'true') {
        $('#cookie-info').fadeTo(500, 1);
    }

    $('#cookie-info #cookie-close').click(function () {
        $('#cookie-info').fadeOut(500);
        Cookies.set('cookiesAcknowledged', true, {
            expires: 168,
            path: '/'
        });
    });

    /* Header Search
    -----------------------------------------*/
    $('.header').on('click', '.trigger-search', function (event) {
        var $input = $(this).prev(),
            $formElement = $(this).closest('.search-form');

        if (!$formElement.hasClass('is-open') || !$input.val().length) {
            $input.val('');
            event.preventDefault();

            if ($formElement.hasClass('is-open')) {
                $formElement.removeClass('is-open');
            }
            else {
                $formElement.addClass('is-open');
            }
        }
    });

    /* Email Subscriptions
    -----------------------------------------*/
    $('#subscribe').submit(function (e) {
        e.preventDefault();

        $elem = $(this);

        $.getJSON(
            this.action + "?callback=?",
            $elem.serialize(),
            function (data) {
                if (data.Status === 400) {
                    $elem.find('.form-input').addClass('error');
                    $('#subscribe-message').text(data.Message);
                }
                else { // 200
                    $elem.fadeOut(300, function () {
                        $('#subscribe-message').text(data.Message);
                    });
                }
            }
        );
    });


    /* Hero Slider
    -----------------------------------------*/
    var swiper = new Swiper('.hero-slider');


    /* ScrollReveal animations
    -----------------------------------------*/
    window.sr = ScrollReveal();
    sr.reveal('.service, .size-approval-logo');


    /* Select2
    -----------------------------------------*/
    $('select').select2({
        minimumResultsForSearch: Infinity
    });

    /* FAQ
    ---------------------------------------- */
    $('.faq-question').on('click', function () {
        $(this).next('.faq-answer').animate({
            opacity: 'toggle',
            height: 'toggle'
        }, 300);

        $(this).toggleClass('opened');
    });


    /* Open and close primary navigation
    ---------------------------------------- */
	$('.cd-primary-nav-trigger').on('click', function () {
		$('.menu-icon').toggleClass('is-clicked');

		//in firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $('.cd-primary-nav').hasClass('is-visible') ) {
			$('.cd-primary-nav').removeClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
				$('body').removeClass('overflow-hidden');
			});
		} else {
			$('.cd-primary-nav').addClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
				$('body').addClass('overflow-hidden');
			});
		}
	});

    function displayDL(target) {
        $('.download-toggle').removeClass('activeDL');
        $('#cat-toggle-' + target).addClass('activeDL');
        $('.download-category').addClass('hidden-download-category');
        $('#data-cat-' + target).removeClass('hidden-download-category');
      }
});
